window.addEventListener("load", function () {
  const targetButton = document.querySelector("button[name='add'].product-form__submit");
  const bisTriggerContainer = document.querySelector(".klaviyo-bis-trigger > button");

  if (targetButton && bisTriggerContainer) {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        // Only run logic if the content or attributes actually changed
        if (mutation.type === "attributes" || mutation.type === "childList") {
          const targetButtonText = targetButton.textContent.trim();
          
          if (targetButtonText === "Sold Out") {
            console.log("MK0: show BIS");
            bisTriggerContainer.style.display = "inline-flex";
          } else {
            console.log("MK0: hide BIS");
            bisTriggerContainer.style.display = "none";
          }
        }
      }
    });

    const config = { attributes: true, childList: true, subtree: true };
    observer.observe(targetButton, config);
  } else {
    // If one is missing, we log exactly which one so you can debug
    if (!targetButton) console.warn("MK0 BIS Fix: Target Add to Cart button not found!");
    if (!bisTriggerContainer) console.warn("MK0 BIS Fix: Klaviyo trigger button not found!");
  }
});